<template>
	<div>

		<v-data-table
			:headers="encabezado"
			:items="fuente.listado"
			item-key="identificador"
			class="elevation-1 mb-16"
			:items-per-page="10000"
			:loading="fuente.listando"
			hide-default-footer
		>
			<template v-slot:item.creación.fecha="{ item }">
				<div v-if="item.creación.fecha">
					{{ new Date(item.creación.fecha.seconds * 1000).toLocaleString('es') }}
				</div>
				<div v-if="item.anulada" class="red--text">
					Anulada
				</div>
			</template>
			<template v-slot:item.fechaDeEmisión="{ item }">
				{{ item.fechaDeEmisión }}
			</template>
			<template v-slot:item.productos="{ item }">
				<ul>
					<li v-for="p in item.productos" :key="`pdcto${p.identificador}`">({{ p.cantidad }}) {{ p.descripción }}</li>
				</ul>
			</template>
			<template v-slot:item.total="{ item }">
				{{ moneda(item.total) }}
			</template>
			<template v-slot:item.acciones="{ item }">
				<v-tooltip bottom v-if="!item.anulada">
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon v-on="on" v-bind="attrs" @click="abrirDiálogoAnulación(item)">
							<v-icon>mdi-cancel</v-icon>
						</v-btn>
					</template>
					<span>Anular factura de compra</span>
				</v-tooltip>
			</template>
		</v-data-table>

		<v-dialog
			v-model="diálogoCreación"
      max-width="900"
			persistent
		>
			<factura-compra-crear
				@guardar="diálogoCreación = false"
				@cancelar="diálogoCreación = false"
			></factura-compra-crear>
		</v-dialog>

		<v-dialog
			v-model="diálogoAnulación"
      max-width="700"
			persistent
		>
			<factura-compra-anular
				:datos="datosSelección"
				@anular="cerrarDiálogoAnulación()"
				@cancelar="cerrarDiálogoAnulación()"
			></factura-compra-anular>
		</v-dialog>

		<v-btn
			fixed
			dark
			fab
			bottom
			right
			color="pink"
			@click.stop="diálogoCreación = true"
		>
			<v-icon>mdi-plus</v-icon>
		</v-btn>

	</div>
</template>

<script>
import { facturasDeCompra } from '@/../../cliente_comun/fuentes'
import { moneda } from '@/../../cliente_comun/utilidades'
import facturaCompraCrear from '@/components/facturaDeCompra.crear.vue'
import facturaCompraAnular from '@/components/facturaDeCompra.anular.vue'

export default {
	name: 'FacturasDeCompra',
  data: () => ({
		fuente: facturasDeCompra,
		encabezado: [
			{ text: 'Fecha de creación', value: 'creación.fecha', sortable: false },
			{ text: 'Fecha de compra', value: 'fechaDeEmisión', sortable: false },
			{ text: 'Productos', value: 'productos', sortable: false },
			{ text: 'Total', value: 'total', align: 'end', sortable: false },
			{ text: '', value: 'acciones', align: 'end', filterable: false, sortable: false },
		],
		diálogoCreación: false,
		diálogoAnulación: false,
		datosSelección: null
	}),
	components: {
		facturaCompraCrear,
		facturaCompraAnular
	},
	mounted: function() {
		this.fuente.inicializar()
	},
	methods: {
		moneda,
		abrirDiálogoAnulación: function(d) {
			if (!d || !d.identificador || !d.productos) {
				window.alert('[2309] Ocurrió un error.')
				return
			}

			this.datosSelección = d
			this.diálogoAnulación = true
		},
		cerrarDiálogoAnulación: function() {
			this.datosSelección = null
			this.diálogoAnulación = false
		}
	}
}
</script>